import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightMode = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 1,
			x2: 12,
			y2: 3
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 21,
			x2: 12,
			y2: 23
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1,
			y1: 12,
			x2: 3,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21,
			y1: 12,
			x2: 23,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4.22,
			y1: 4.22,
			x2: 5.64,
			y2: 5.64
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 18.36,
			y1: 18.36,
			x2: 19.78,
			y2: 19.78
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4.22,
			y1: 19.78,
			x2: 5.64,
			y2: 18.36
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 18.36,
			y1: 5.64,
			x2: 19.78,
			y2: 4.22
		})
	]
});
export default SvgLightMode;
